import { TableCell, TableRow } from '@mui/material';
import { useSelector } from 'react-redux';
import { formatUtcDateTimeInLabTimeZone } from 'Utils/Common/LabTimeZone';

function Row({
    item,
    key,
}: any) {
    const labTimeZone = useSelector(
        (state: any) => state?.Reducer?.selectedTenantInfo?.labTimeZone
    );

    return (
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }} key={item.id}>
            <TableCell align="left" scope="row">
                <span>{item.firstName}</span>
            </TableCell>
            <TableCell align="left" scope="row">
                <span>{item.lastName}</span>
            </TableCell>
            <TableCell align="left" scope="row">
                <span>{item.positionTitle}</span>
            </TableCell>
            <TableCell align="left" scope="row">
                <span>{item.salesRepNumber}</span>
            </TableCell>
            <TableCell align="left" scope="row">
                <span>{item.email}</span>
            </TableCell>
            <TableCell align="left" scope="row">
                <span>{item.phoneNumber}</span>
            </TableCell>
            <TableCell align="left" scope="row">
                <span>{item.actionBy}</span>
            </TableCell>
            <TableCell align="left" scope="row">
                <span>{formatUtcDateTimeInLabTimeZone(item.actionDate, labTimeZone, 'M/d/yyyy') ?? new Date(item.actionDate).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' })}</span>
            </TableCell>
        </TableRow >


    )
}

export default Row
{ }